export const headerTitleStyle = theme => ({
    title: {
        // flexGrow: 1,
    }
})